import { primitiveColorTokens } from "src/assets/layout/styles/tokens/primitive";

export const accordion = {
    header: {
        color: primitiveColorTokens.grey[800],
        background: primitiveColorTokens.translucentBlue[600],
        hoverBackground: primitiveColorTokens.translucentBlue[600],
        activeBackground: primitiveColorTokens.translucentBlue[600],
        activeHoverBackground: primitiveColorTokens.translucentBlue[600],
        padding: "0.45rem 0",
        // NOTE - BS - the header.toggleIcon design tokens aren't currently working.
        //             Style with CSS overrides for now.
    },
    content: {
        padding: "0",
    },
    css: () => {
        /**
         * Base Overrides for p-accordion
         * NOTE - BS - the p-accordion-toggle-icon class is not getting applied
         * to the svg icon. Target it via the p-accordion-header class
         * instead.
         */
        const base = `
            .p-accordionheader {
                justify-content: start !important;
            }

            .p-accordionheader > *:first-child {
                order: 2;
            }

            .p-accordionheader svg {
                color: var(--p-azara-blue-450);
                transform: scale(0.7) rotate(270deg);
            }

            .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader .p-accordionheader-toggle-icon {
                color: var(--p-azara-blue-450) !important;
                transform: scale(0.7) rotate(180deg);
            }
        `;

        return base;
    },
};
